import React from 'react';
import InlineInputForm from '../../common/inlineInputForm';
import InlineDropdown from '../../common/inlineDropDown';
import AssembliesTable from './assembliesTable';

export default function AddAssembly({ warehouses }) {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>AddAssembly</label>
					</div>
				</div>
			</div>
			<br />
			<div className="panel panel-default">
				<div className="panel-body">
					<div className="row" id="inline-input-forms">
						<div className="col-sm-4">
							<InlineDropdown id="source_warehouse" name="Source Warehouse" values={warehouses} />
							<InlineDropdown
								id="destination_warehouse"
								name="Destination Warehouse"
								values={warehouses}
							/>
							<InlineInputForm id="product_code" value="" name="*Product Code" />
							<InlineInputForm id="product_description" value="" name="*Product Description" />
							<InlineInputForm
								disable="disabled"
								id="assembled_quantity"
								value="0"
								name="Assembled Quantity"
							/>
							<InlineInputForm
								disable="disabled"
								id="can_assemble_qty"
								value="0"
								name="Can Assemble Qty"
							/>
							<InlineInputForm
								disable="disabled"
								id="can_assemble_qty_ll_levels"
								value="0"
								name="Can Assemble Qty (All levels) "
							/>
						</div>
						<div className="col-sm-4">
							<InlineInputForm disable="disabled" id="total_cost" value="0" name="Total Cost" />
							<InlineInputForm
								disable="disabled"
								id="assemble_by"
								value=""
								type="date"
								name="Assemble By"
							/>
							<InlineDropdown
								disable="disabled"
								id="assembly_template"
								name="Assembly Template"
								values={['Globuss Default', 'Default Assembly']}
							/>
						</div>
						<div className="col-sm-4">
							<div className="form-inline">
								<div className="form-group">
									<label htmlFor="comments">Comments</label>
									<textarea rows="7" type="text" className="form-control" id="comments" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="panel panel-default">
				<div className="panel-body">
					<div className="row" id="settings-field">
						<div className="col-md-6 padding-right">
							<label className="input-label" htmlFor="component_product">
								*Component Product
							</label>
							<input
								disabled
								type="text"
								className="form-control"
								id="component_product"
								name="component_product"
							/>
						</div>
						<div className="col-md-2 padding-0">
							<label className="input-label" htmlFor="qauntity">
								*Quantity
							</label>
							<input disabled type="text" className="form-control" id="qauntity" name="qauntity" />
						</div>
						<div className="col-md-2 padding-0">
							<label className="input-label" htmlFor="wastage_qauntity">
								Wastage Qty
							</label>
							<input
								disabled
								type="text"
								className="form-control"
								id="wastage_qauntity"
								name="wastage_qauntity"
							/>
						</div>
						<div className="col-md-2" id="add-production-btn">
							<label className="input-label">Add</label>
							<button disabled type="button" className="btn btn-success btn-sm">
								Add
							</button>
						</div>
					</div>
					<br />
					<AssembliesTable />
				</div>
			</div>
		</>
	);
}
